import {
  getCalendarInterval,
  getUTCDayRangePercentage,
  getUTCDayRange,
  getCustomDateRange,
} from "../utils/utils";

export const kpiCalls = (
  getAllVisualizationData,
  selectedDropdownValue,
  item,
  success,
  error
) => {
  const getOffsetFromDropdownValue = (dropdownValue) => {
    switch (dropdownValue) {
      case "today":
        return 0;
      case "thisWeek":
        return 10;
      case "lastWeek":
        return 7;
      case "thisLastMonth":
        return 30;
      case "thisMonth":
        return 30;
      case "last3Month":
        return 90;
      case "last6Months":
        return 180;
      case "last12Months":
        return 365;
      case "thisYear":
        return 365;
      default:
        return 0;
    }
  };
  const calendarInterval = getCalendarInterval(selectedDropdownValue);
  if (
    selectedDropdownValue === "customDate" &&
    !item?.singleStartDate &&
    (!item?.startDate || !item?.endDate)
  ) {
    return;
  }

  let kpiPayload;
  if (
    selectedDropdownValue === "customDate" &&
    (item?.singleStartDate || (item?.startDate && item?.endDate))
  ) {
    kpiPayload = {
      ...getCustomDateRange(
        item?.singleStartDate,
        item?.startDate,
        item?.endDate
      ),
      attributeFilters: item?.attributeFilters,
      advancedAttributeFilters: item?.advancedAttributeFilters,
    };
  } else {
    kpiPayload = {
      ...getUTCDayRange(selectedDropdownValue),
      attributeFilters: item?.attributeFilters,
      advancedAttributeFilters: item?.advancedAttributeFilters,
    };
  }
  // Call the first API
  getAllVisualizationData(
    item.url,
    kpiPayload,
    function (kpiData) {
      if (selectedDropdownValue === "customDate") {
        // Only one API call for customDate
        const getValueFromMetrics = (metrics, fieldName) => {
          return metrics.hasOwnProperty(fieldName) ? metrics[fieldName] : 0;
        };

        const getValueFromPoints = (points, fieldName) => {
          const point = points.find((point) => point.hasOwnProperty(fieldName));

          return point ? point[fieldName] : 0;
        };

        const value =
          getValueFromMetrics(kpiData?.metrics, item?.fieldName) ||
          getValueFromPoints(kpiData?.points, item.fieldName);
        const valueForLocale =
          getValueFromPoints(kpiData?.points, item?.localeFieldName) ||
          getValueFromMetrics(kpiData?.metrics, item?.localeFieldName);
        const countForLocale =
          getValueFromPoints(kpiData?.points, item?.countfieldName) ||
          getValueFromMetrics(kpiData?.metrics, item?.countfieldName);

        const data = {
          value,
          valueForLocale,
          title: item?.title,
          countForLocale,
          absoluteDifference: item?.showAbsoluteDifference,
          showTooltip: item?.showTooltip,
          tooltipContent: item?.tooltipContent,
          offSet: getOffsetFromDropdownValue(selectedDropdownValue),
          previousData: false, // No previous data for customDate
        };
        success(data);
      } else {
        // Call the second API for other dropdown values
        const kpiComparingPayload = {
          ...getUTCDayRangePercentage(selectedDropdownValue),
          attributeFilters: item?.attributeFilters,
          advancedAttributeFilters: item?.advancedAttributeFilters,
        };
        getAllVisualizationData(
          item.url,
          kpiComparingPayload,
          function updateKpiData(prevPerioddata) {
            const getValueFromMetrics = (metrics, fieldName) => {
              return metrics.hasOwnProperty(fieldName) ? metrics[fieldName] : 0;
            };

            const getValueFromPoints = (points, fieldName) => {
              const point = points.find((point) =>
                point.hasOwnProperty(fieldName)
              );

              return point ? point[fieldName] : 0;
            };

            const value =
              getValueFromMetrics(kpiData?.metrics, item?.fieldName) ||
              getValueFromPoints(kpiData?.points, item.fieldName);
            const valueForLocale =
              getValueFromPoints(kpiData?.points, item?.localeFieldName) ||
              getValueFromMetrics(kpiData?.metrics, item?.localeFieldName);
            const countForLocale =
              getValueFromPoints(kpiData?.points, item?.countfieldName) ||
              getValueFromMetrics(kpiData?.metrics, item?.countfieldName);

            const preValue =
              getValueFromPoints(prevPerioddata?.points, item?.fieldName) ||
              getValueFromMetrics(prevPerioddata?.metrics, item?.fieldName);

            const percent =
              !preValue || preValue === 0 || value - preValue === 0
                ? 0
                : ((value - preValue) / preValue) * 100;
            const successPercent = preValue === 0 ? 0 : value - preValue;
            const absoluteDifference = item?.showAbsoluteDifference;
            const offSet = getOffsetFromDropdownValue(selectedDropdownValue);
            const previous =
              prevPerioddata?.points?.length === 0 ? false : true;
            let data = {
              value,
              percent,
              successPercent,
              valueForLocale,
              title: item?.title,
              countForLocale,
              absoluteDifference,
              showTooltip: item?.showTooltip,
              tooltipContent: item?.tooltipContent,
              offSet,
              previousData: previous,
            };
            success(data);
          },
          function (errorMsg) {
            error(errorMsg);
          }
        );
      }
    },
    function (errorMsg) {
      error(errorMsg);
    }
  );
};
